/**
 * Nome da toggled strategy no Unleash (tipo release).
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const BACKOFFICE_ATENDIMENTO_UNLEASH_FLAG = "BackofficeAtendimento" as const;

/**
 * Listagem de eventos (ações por grupo), botão global do assistente de cadastro e wizard de edição.
 * Desligada: comportamento anterior (só "+" por tipo de evento no grupo, formulário clássico no sheet).
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const EVENTOS_NOVA_EXPERIENCIA_UNLEASH_FLAG = "EventosNovaExperiencia" as const;

/**
 * Assistente de montagem de equipes (Voluntários → Equipes).
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const ASSISTENTE_MONTAGEM_EQUIPES_UNLEASH_FLAG =
  "AssistenteMontagemEquipes" as const;

/**
 * EAD no módulo de ensino: modalidade da turma, player, progresso, fórum de dúvidas.
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const ENSINO_EAD_UNLEASH_FLAG = "EnsinoEad" as const;

/**
 * Barra flutuante de ações em massa nas listagens.
 * Desligada: só o dropdown de ações da tela (screenActions).
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const BULK_ACTIONS_PANEL_UNLEASH_FLAG = "BulkActionsPanel" as const;

/**
 * Paridade web (funcional + visual): módulo Devocionais alinhado ao mobile
 * — home/explorar, wizard com origens, atalhos círculo/equipe/voluntários.
 * Desligada: UI legada do módulo e formulário manual de grupo.
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const DEVOCIONAL_ORIGEM_PARIDADE_UNLEASH_FLAG =
  "DevocionalOrigemParidade" as const;

/**
 * Modo de envio manual (participante por participante) no envio de mensagens em massa.
 * Desligada: envio sempre automático (fila em lote), sem opção de alternar.
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const LISTAGEM_MANUAL_ENVIOS_UNLEASH_FLAG = "ListagemManualEnvios" as const;

/**
 * Meta Pixel por evento: UI de configuração e rastreamento na página pública de inscrição.
 * Desligada: não exibe campos no cadastro do evento e não carrega o Pixel no funil.
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const META_PIXEL_EVENTOS_UNLEASH_FLAG = "MetaPixelEventos" as const;

/**
 * Evento teste (trial): permite igrejas sem organização cadastrada criar um evento
 * completo direto de /trial, sem assinatura prévia. Desligada: rota /trial e os
 * botões "Crie seu evento" ficam indisponíveis.
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const PRIMEIRO_EVENTO_TESTE_UNLEASH_FLAG = "primeiroEventoTeste" as const;

/**
 * Formulário de inscrição novo (atividade 883): checkout com cabeçalho de etapas, resumo lateral
 * no computador e revisão + termo numa tela só. Só visual: mesmas regras e mesma busca por e-mail.
 * Liberada por igreja: a org dona do evento entra no contexto do Unleash (ver useInscricaoNova).
 * Desligada: funil de inscrição atual.
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const INSCRICAO_NOVA_UNLEASH_FLAG = "InscricaoNova" as const;

/**
 * SysIgreja Plus (assinatura B2C leigo). Desligada: esconde aquisição/marketing;
 * assinantes (grant admin/cupom/MP) continuam acessando benefícios via entitlement.
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const SYSIGREJA_PLUS_UNLEASH_FLAG = "SysIgrejaPlus" as const;

/**
 * Banner de download do app nativo na área logada (`/sistema`).
 * Mesmo nome em `BANNER_APP_FLAG` (`lib/mobile-app-banner.ts`).
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const BANNER_APP_UNLEASH_FLAG = "BannerApp" as const;

/**
 * Barra de busca global (estilo Drive) no header: substitui o atalho/chip
 * de EventosIA e Agenda IA. Desligada: ⌘K continua abrindo o assistente.
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const BUSCA_GLOBAL_UNLEASH_FLAG = "BuscaGlobal" as const;

/**
 * DataTable refatorado (V3) com o visual das homes em painel. Desligada: DataTableV2.
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const NEW_DATA_TABLE_UNLEASH_FLAG = "NewDataTable" as const;

/**
 * Botões "Adicionar à Apple Wallet" / "Salvar no Google Wallet" nos ingressos
 * (Meus ingressos e e-mails de confirmação). Mesmo nome em `CARTEIRA_DIGITAL_FEATURE_FLAG` (backend).
 * Crie a flag com o mesmo nome em https://unleash.sysigreja.com
 */
export const CARTEIRA_DIGITAL_UNLEASH_FLAG = "CarteiraDigital" as const;

/** #704: Imprimir credencial pelo PDF do servidor (segmentada por usuário). Mesmo nome no backend. */
export const CREDENCIAL_PDF_SERVIDOR_UNLEASH_FLAG = "CredencialPdfServidor" as const;

/** Modo demonstração do onboarding do trial (`?onboardingPreview=1`), segmentado por usuário. */
export const TRIAL_ONBOARDING_PREVIEW_UNLEASH_FLAG = "TrialOnboardingPreview" as const;
